/*
 * star-form-copy.js (11 Oct 2026, reworked 20 Oct 2026)
 * The store's own contact forms keep working exactly as before: Shopify sends them natively.
 * A COPY of the same fields goes to the Star Safety request list (chat.starsafetysupplies.com.au
 * /api/site-form), so every request from the website and from the chat is in one list in the store
 * admin, and the team gets the branded e-mail with the PDF.
 *
 * 20 Oct 2026: with Shopify's bot protection (hCaptcha) on, the store stops the submit event, checks
 * the visitor and then posts the form from code, which fires no second submit event; the 11 Oct
 * version skipped stopped events, so no copy ever came from a real browser. Now the fields are read
 * when the form is submitted:
 *   - the browser posts the form straight away -> the copy goes at once (as before)
 *   - the submit was stopped (the bot check, which posts the form itself once the visitor passes, or a
 *     step of a multi-step form) -> the copy waits in this tab (sessionStorage), the latest one wins,
 *     and goes when Shopify comes back with ?contact_posted=true: only for a form Shopify accepted
 * It never blocks, delays or changes the form; if the copy fails, the native form still goes.
 */
(function () {
  'use strict';
  var API = 'https://chat.starsafetysupplies.com.au/api/site-form';
  var KINDS = [
    ['ContactForm-', 'contact'], ['StarQuoteForm-', 'quote'], ['StarOrderTracking-', 'track'],
    ['StarTradeForm-', 'trade'], ['TrainingEnquiryForm', 'training'], ['StarCustomSign-', 'custom_sign']
  ];
  var WAITING = 'starFormCopy';
  var MAX_WAIT = 30 * 60 * 1000;

  function kindOf(form) {
    var id = form.getAttribute('id') || '';          // form.id can be a field named "id"
    for (var i = 0; i < KINDS.length; i++) {
      if (id.indexOf(KINDS[i][0]) === 0) return KINDS[i][1];
    }
    return null;
  }

  function fieldsOf(form) {
    var out = {};
    var data = new FormData(form);
    data.forEach(function (value, name) {
      if (typeof value !== 'string') return;
      var m = /^contact\[(.+)\]$/.exec(name);
      if (!m || !value.trim()) return;
      var key = m[1];
      out[key] = out[key] ? out[key] + ', ' + value.trim() : value.trim();
    });
    return out;
  }

  function copyOf(form) {
    if (!form || form.tagName !== 'FORM') return null;
    var type = form.querySelector('input[name="form_type"]');
    if (!type || type.value !== 'contact') return null;
    var kind = kindOf(form);
    if (!kind) return null;
    var fields = fieldsOf(form);
    if (!fields.email) return null;
    return JSON.stringify({ form: kind, page: location.pathname, fields: fields });
  }

  function send(body) {
    try {
      if (navigator.sendBeacon &&
          navigator.sendBeacon(API, new Blob([body], { type: 'text/plain;charset=UTF-8' }))) return;
    } catch (e) { /* fall through */ }
    try {
      fetch(API, { method: 'POST', body: body, keepalive: true, mode: 'no-cors',
                   headers: { 'Content-Type': 'text/plain;charset=UTF-8' } });
    } catch (e) { /* the native form still goes */ }
  }

  function keep(body) {
    try {
      sessionStorage.setItem(WAITING, JSON.stringify({ body: body, at: Date.now() }));
      return true;
    } catch (e) { return false; }
  }

  function takeKept() {
    try {
      var raw = sessionStorage.getItem(WAITING);
      sessionStorage.removeItem(WAITING);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  // window, bubble phase: every handler on the form (the bot check) and on the document has run
  window.addEventListener('submit', function (event) {
    var form = event.target;
    var body = copyOf(form);
    if (!body) return;
    if (!event.defaultPrevented) { send(body); return; }
    if (!keep(body) && form.hasAttribute('data-hcaptcha-bound')) send(body);   // no storage: send now
  });

  // back from Shopify after the bot check: the form was accepted
  if (/[?&]contact_posted=true(&|$)/.test(location.search)) {
    var kept = takeKept();
    if (kept && kept.body && Date.now() - kept.at < MAX_WAIT) send(kept.body);
  }
})();
